import { Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular/standalone';

import { AppUpdateModalComponent } from '../../../components';
import { IUpdateAppVersionModalPresenter } from '../domain/services/update-modal.interface';

/**
 * Service for showing the update modal
 * Implements the IUpdateModalService interface
 */
@Injectable({
    providedIn: 'root'
})
export class UpdateAppVersionModalPresenter implements IUpdateAppVersionModalPresenter {
    constructor(private modalController: ModalController) {}

    /**
     * Shows a modal informing the user that an update is available
     * @returns A Promise that resolves when the modal is presented
     */
    async showUpdateModal(): Promise<void> {
        const modal = await this.modalController.create({
            component: AppUpdateModalComponent,
            cssClass: 'modal-window',
            backdropDismiss: false,
            keyboardClose: false,
            showBackdrop: true
        });
        await modal.present();
    }
}
